import { observer, inject } from 'mobx-react';
import React from 'react';
import MainSectionLayout from '../layout/MainSectionLayout';
import { Instance } from 'mobx-state-tree';
import { TLCode } from '../../common/enums';
import {
  BankHolidayStore,
  BankHolidayDateStore,
  ApplicationStore,
  LocaleStore,
  PharmacyDetailedStore,
  AuthenticationStore,
} from '../../store';
import { RouteComponentProps } from 'react-router-dom';
import { BankHoliday } from '../../store/models/BankHoliday';
import styled from '@emotion/styled';
import { InputGroup } from '@blueprintjs/core';
import BaseGrid from '../common/grid/BaseGrid';
import { ColDef } from 'ag-grid-community';

interface BankHolidayDatesPageProps extends RouteComponentProps<{ pharmacyId: string }> {
  BankHolidayStore?: Instance<typeof BankHolidayStore>;
  BankHolidayDateStore?: Instance<typeof BankHolidayDateStore>;
  LocaleStore?: Instance<typeof LocaleStore>;
  ApplicationStore?: Instance<typeof ApplicationStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
}

interface BankHolidayDatesPageState {
  isLoading: boolean;
  BankHolidays: Array<Instance<typeof BankHoliday>>;
  filter: any;
}

const ContainerCol = styled.div`
  display: 'flex',
  flex-direction: 'column',
  height: '100%',
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  .bp3-button {
    margin-right: 3px;
  }
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-right: 5%;
  padding-bottom: 5px;
`;
const DivRight = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
  .bp3-icon {
    margin-right: 3px;
  }
`;

@inject('BankHolidayStore')
@inject('BankHolidayDateStore')
@inject('PharmacyDetailedStore')
@inject('ApplicationStore')
@inject('LocaleStore')
@inject('AuthenticationStore')
@observer
class BankHolidayDatesPage extends React.Component<BankHolidayDatesPageProps, BankHolidayDatesPageState> {
  state = {
    isLoading: false,
    filter: '',
    BankHolidays: [],
    BankHolidayDates: [],
    searchCriteria: {
      year: null,
      treated: true,
      pharmacyId: null,
    },
  };

  _isMounted = false;

  async componentDidMount() {
    this._isMounted = true;
    const { BankHolidayStore, BankHolidayDateStore } = this.props;
    this._isMounted && this.setState({ isLoading: true });
    await BankHolidayStore!.loadList();
    await BankHolidayDateStore!.loadList();
    this._isMounted && this.setState({ isLoading: false });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  private getColumnDefs = (): ColDef[] => {
    const { LocaleStore } = this.props;
    return [
      {
        headerName: LocaleStore!.getText(TLCode.PHARMACIES_ApbNum),
        field: 'year',
        width: 50,
      },
      {
        headerName: LocaleStore!.getText(TLCode.PHARMACIES_PharmacyName),
        field: 'date',
      },
    ];
  };
  buildGridData = () => {
    return this.props.BankHolidayDateStore!.dataList.map((p) => ({
      bankHolidayDateId: p.bankHolidayDateId,
      date: p.date,
    }));
  };

  setFilterText(filter) {
    this.setState({
      filter,
    });
  }

  render() {
    const { BankHolidayStore, BankHolidayDateStore, LocaleStore, AuthenticationStore } = this.props;
    const bankHolidayList = BankHolidayStore!.dataList;
    const bankHolidayDateList = BankHolidayDateStore!.dataList;
    const locale = LocaleStore!.currentLocale;
    const userRoles = AuthenticationStore!.userActionCodes;

    return (
      <MainSectionLayout isLoading={this.state.isLoading} title={TLCode.PHARMACIES_Title}>
        <ContainerCol>
          <DivLine>
            <DivLeft>
              <InputGroup
                placeholder="Filter..."
                leftIcon="search"
                value={this.state.filter}
                onChange={(e) => this.setFilterText(e.target.value)}
              />
            </DivLeft>
            <DivRight />
            <br />
          </DivLine>
          <BaseGrid
            keyName="pharmacyId"
            columnDefs={this.getColumnDefs()}
            rowData={this.buildGridData()}
            loading={this.state.isLoading}
            quickFilterText={this.state.filter}
          />
        </ContainerCol>
      </MainSectionLayout>
    );
  }
}

export default BankHolidayDatesPage;
